import { render, staticRenderFns } from "./3TravelPlans.vue?vue&type=template&id=34b0bf7a"
import script from "./3TravelPlans.vue?vue&type=script&lang=js"
export * from "./3TravelPlans.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports